import handleAppWindow from "./windowState";
import { changeDragable } from "./draggable";
import handleTaskView from "./taskView";
import { combineReducers } from "redux";
import { handleDockPosition, handleDockVisibility } from "./dock";
import handleLibraryImages from "./gallery";
import handleNotifications from "./handleNotifications";

const roodReducer = combineReducers({
    handleAppWindow,
    changeDragable,
    handleDockPosition,
    handleDockVisibility,
    handleTaskView,
    handleLibraryImages,
    handleNotifications
})


export default roodReducer